import { makePieActionObjs } from "shared/imports/pieActionGenerators"

const getReviewObjs = makePieActionObjs("get", "review")
export const getReviewActionDict = getReviewObjs.pieDict

const postReviewObjs = makePieActionObjs("post", "review")
export const postReviewActionDict = postReviewObjs.pieDict

const patchReviewObjs = makePieActionObjs("patch", "review")
export const patchReviewActionDict = patchReviewObjs.pieDict

const actionTypes = {
    SET_ALIGNMENT_START: "profiles/SET_ALIGNMENT_START",
    SET_ALIGNMENT_SUCCESS: "profiles/SET_ALIGNMENT_SUCCESS",
    SET_ALIGNMENT_FAIL: "profiles/SET_ALIGNMENT_FAIL",

    GET_ALIGNMENT_START: "profiles/GET_ALIGNMENT_START",
    GET_ALIGNMENT_SUCCESS: "profiles/GET_ALIGNMENT_SUCCESS",
    GET_ALIGNMENT_FAIL: "profiles/GET_ALIGNMENT_FAIL",

    SET_STANCE_START: "profiles/SET_STANCE_START",
    SET_STANCE_SUCCESS: "profiles/SET_STANCE_SUCCESS",
    SET_STANCE_FAIL: "profiles/SET_STANCE_FAIL",

    GET_STANCE_START: "profiles/GET_STANCE_START",
    GET_STANCE_SUCCESS: "profiles/GET_STANCE_SUCCESS",
    GET_STANCE_FAIL: "profiles/GET_STANCE_FAIL",

    SET_PRIORITY_START: "profiles/SET_PRIORITY_START",
    SET_PRIORITY_SUCCESS: "profiles/SET_PRIORITY_SUCCESS",
    SET_PRIORITY_FAIL: "profiles/SET_PRIORITY_FAIL",

    GET_PRIORITY_START: "profiles/GET_PRIORITY_START",
    GET_PRIORITY_SUCCESS: "profiles/GET_PRIORITY_SUCCESS",
    GET_PRIORITY_FAIL: "profiles/GET_PRIORITY_FAIL",

    ...getReviewObjs.actionTypes,
    ...patchReviewObjs.actionTypes,
    ...postReviewObjs.actionTypes,
}

export default actionTypes

export const setAlignmentTypes = {
    start: actionTypes.SET_ALIGNMENT_START,
    success: actionTypes.SET_ALIGNMENT_SUCCESS,
    fail: actionTypes.SET_ALIGNMENT_FAIL,
}

export const getAlignmentTypes = {
    start: actionTypes.GET_ALIGNMENT_START,
    success: actionTypes.GET_ALIGNMENT_SUCCESS,
    fail: actionTypes.GET_ALIGNMENT_FAIL,
}

export const setStanceTypes = {
    start: actionTypes.SET_STANCE_START,
    success: actionTypes.SET_STANCE_SUCCESS,
    fail: actionTypes.SET_STANCE_FAIL,
}

export const getStanceTypes = {
    start: actionTypes.GET_STANCE_START,
    success: actionTypes.GET_STANCE_SUCCESS,
    fail: actionTypes.GET_STANCE_FAIL,
}

export const setPriorityTypes = {
    start: actionTypes.SET_PRIORITY_START,
    success: actionTypes.SET_PRIORITY_SUCCESS,
    fail: actionTypes.SET_PRIORITY_FAIL,
}

export const getPriorityTypes = {
    start: actionTypes.GET_PRIORITY_START,
    success: actionTypes.GET_PRIORITY_SUCCESS,
    fail: actionTypes.GET_PRIORITY_FAIL,
}
